import styled from "@emotion/styled";

export const HiddenDiv = styled.div`
    display: none;
`;
